import Modal from "@common/Modal";
import ReactSelect from "@common/ReactSelect";
import { useEffect, useRef, useState } from "react";
import * as HELPER from "../../../config/helper";
import { handleManualPremiumChange,handleCoverageChange,handlePassengerChange,totalAddonCost,handleCheckboxChange } from './functions/addon.fn';
import { WITH_RULE_ENGINE } from "@src/config/constant";
import { useLanguage } from "@src/context/LanguageContext";


interface AddonModalProps {
    show: boolean;
    handleClose: () => void;
    onConfirm: () => void;
    basicAddons:any;
    addonState: any;
    setAddonState: React.Dispatch<React.SetStateAction<any>>,
    requestData:Record<string,any>,
    error:any,
    setError:React.Dispatch<React.SetStateAction<any>>,

}

export default function AddonPopupModal(
    {
    show,
    handleClose,
    onConfirm,
    basicAddons,
    addonState,
    setAddonState,
    requestData,
    error,
    setError
}: AddonModalProps) {

    const isRuleEngine = requestData?.rule_engine === WITH_RULE_ENGINE;
    const {translations} = useLanguage();
    const [openApplicableInfoId, setOpenApplicableInfoId] = useState<number | null>(null);
    const applicableInfoRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleOutsideClick = (event: MouseEvent) => {
            if (
                applicableInfoRef.current &&
                !applicableInfoRef.current.contains(event.target as Node)
            ) {
                setOpenApplicableInfoId(null);
            }
        };

        updatedPremiumAmt();
        document.addEventListener("mousedown", handleOutsideClick);

        return () => {
            document.removeEventListener("mousedown", handleOutsideClick);
        };
    }, []);
    
    const handleCoverageChangeloc = (item: any, option: any) => {
        handleCoverageChange(item, option, setAddonState, isRuleEngine);
    };

    const handleManualPremiumChangeLoc = (item: any, value: any) => {
        handleManualPremiumChange(item, value, setAddonState,setError);
    };
    const handlePassengerChangeLoc = (addon: any, selected: any) => {
        handlePassengerChange(addon, selected, setAddonState,requestData,addonState);
    } 
    const handleCheckboxChangeLoc = (addon: any, checked: boolean) => {
        handleCheckboxChange(requestData, setAddonState, addon, checked,setError);
    }   

    const totalPremiumAmt = totalAddonCost(addonState);
    const updatedPremiumAmt = ()=>{
        const updatePrimiumState = {...addonState}
        for(let row of basicAddons){
            if(updatePrimiumState[row.id]){
                if(row?.coverage_list?.length === 0 && isRuleEngine){
                    updatePrimiumState[row.id] = {
                        ...updatePrimiumState[row.id],
                        premium: row.premium_amount
                    }   
                }
            }
        }
        setAddonState(updatePrimiumState)
    }

    return (
        <div className="addon-modal-wrapper model-outer">
            <Modal show={show} handleClose={handleClose}>
                <div className="addon-modal">

                <div className="addon-header modal-header">
                    <h2>{translations?.CREATE_APP?.AVAILABLE_ADDONS}</h2>
                    <small>{requestData?.vehicle}</small>
                </div>
                <div className="addon-body modal-body">
                    {basicAddons.map((item: any) => {
    
                        const state = addonState[item.id] || {};
                        const isChecked = state.checked || false;
                        const isDisabled = item.is_required;
                        const isGreyed = !item.is_enable;
                        const hasDropdown = item.coverage_list?.length > 0;        


                        return (
                        <div key={item.id} className={`addon-row ${isGreyed ? "isGreyed" : ""}`}>
                            <div className="addon-left">
                            <div className="custom-control custom-checkbox">
                                <input
                                id={`basic_${item.id}`}
                                type="checkbox"
                                className="custom-control-input"
                                checked={isChecked}
                                disabled={isDisabled}
                                onChange={(e:any) => handleCheckboxChangeLoc(item,e?.target?.checked)}
                                />
                                <label className="custom-control-label" htmlFor={`basic_${item.id}`}>
                                {item.name}
                                </label>
                            </div>

                            {item?.note && (
                                <div
                                    className="applicable-info-wrap"
                                    ref={openApplicableInfoId === item.id ? applicableInfoRef : null}
                                >
                                    <span className="applicable-txt">
                                        {item.note}
                                        <button
                                            type="button"
                                            className="applicable-info-btn"
                                            onClick={(event) => {
                                                event.preventDefault();
                                                event.stopPropagation();
                                                setOpenApplicableInfoId((prev) => (prev === item.id ? null : item.id));
                                            }}
                                        >
                                            <i className="ic-info-icon1 addon-i-info"></i>
                                        </button>
                                    </span>

                                    {openApplicableInfoId === item.id && (
                                        <div className="applicable-info-popup">
                                            {item.note_desc}
                                        </div>
                                    )}
                                </div>
                            )}

                            {hasDropdown && isChecked && (
                                <div className="coverage-amt-dropdown">
                                <ReactSelect
                                        options={item.coverage_list.map((c: any) => ({
                                        value: c.value,
                                        label: `${HELPER.addCurrencyFormatting(c.label)}`,
                                        premium: c.premium_amount
                                    }))}
                                    value={state?.coverage}
                                    placeholder={translations?.CREATE_APP?.CHOOSE_COVERAGE_AMOUNT}
                                    fieldKey={`coverage_${item.id}`}
                                    innerClass="select-partenrt-dropdown"
                                    handleChange={(option: any) => handleCoverageChangeloc(item, option)}
                                />
                                </div>
                            )}

                            {item.seat_capacity_list?.length > 0 && (state.checked) && (
                                            <div className="coverage-amt-dropdown m-t-10">
                                                <ReactSelect
                                                    options={item.seat_capacity_list.map((s: any) => ({
                                                        value: s.value,
                                                        label: s.label
                                                    }))}
                                                    value={state.passengers || null}
                                                    handleChange={(e: any) => handlePassengerChangeLoc(item, e)}
                                                    placeholder={translations?.CREATE_APP?.NO_OF_PASSENGER}
                                                    fieldKey={`passenger_${item.id}`}
                                                    fieldSetClassName="col-md-12"
                                                    innerClass="select-partenrt-dropdown"
                                                />
                                            </div>
                                        )}
                            </div>

                           {isChecked && (
                                <div className="addon-right">
                                    {!isRuleEngine ? (
                                        <>
                                            <input
                                                type="text"
                                                className="add-on-input"
                                                value={HELPER.addCurrencyFormatting(state.premium)}
                                                spellCheck={false}
                                                onChange={(event) => {
                                                    const inputValue = event.target.value;
                                                    const finalValue = HELPER.removeCurrencyFormattingId(inputValue)
                                                    handleManualPremiumChangeLoc(item, finalValue);
                                                }}
                                            />

                                            {error[`premium_${item.id}`] && (
                                                <span className="error-txt">
                                                    {error[`premium_${item.id}`]}
                                                </span>
                                            )}
                                        </>
                               
                                    ) : (
                                    <span className="price-pill">
                                        {hasDropdown
                                        ? HELPER.addCurrencyFormatting((state?.premium)) || "0"
                                        : HELPER.addCurrencyFormatting(state.premium)}
                                    </span>
                                    )}
                                </div>
                            )}
                        </div>
                        );
                    })}
                </div>
                <div className="addon-footer modal-footer">
                    <div className="total">
                        {translations?.CREATE_APP?.TOTAL_ADDON_COST} - {totalPremiumAmt}
                    </div>
                    <button className="btn-primary full" onClick={onConfirm}>
                    {translations?.CREATE_APP?.ADD_ADDONS}
                    </button>
                </div>

                </div>
            </Modal>
        </div>
    );
}
